/**
 * Save a file the best way each platform allows.
 * Touch devices (iOS/Android/Quest): open the native share sheet, which offers
 * "Save Image/Video" straight to the gallery/Photos. Desktop / WebView fallback:
 * a normal download (the Android app's download listener routes that to the
 * gallery). Works for images AND videos.
 */
export async function saveMedia(url?: string, filename?: string) {
  if (!url) return;
  const isTouch = matchMedia("(pointer: coarse)").matches;
  try {
    if (isTouch && navigator.canShare) {
      const res = await fetch(url);
      const blob = await res.blob();
      const file = new File([blob], filename ?? "download", { type: blob.type });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file] });
        return;
      }
    }
  } catch {
    /* share cancelled or unsupported — fall through to a normal download */
  }
  const a = document.createElement("a");
  a.href = url;
  a.download = filename ?? "";
  a.target = "_blank";
  a.rel = "noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
